module.exports = __webpack_public_path__ + "static/media/1.54f18b23.jpeg";